import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const Container = styled(Box)`
  position: relative;
  width: 100%;
`;
